/**
 * Tipos de suscripción.
 *
 * Los valores `pilates-*` son datos: están escritos en `nombreSuscripcion` en
 * todos los documentos de Mongo y en las comparaciones de medio front. Cambiarlos
 * exige una migración, así que de momento se quedan como están y lo que se
 * generaliza es lo que ve el usuario.
 *
 * Regla: el valor crudo NUNCA se pinta en pantalla — para eso está
 * `etiquetaSuscripcion`. Un centro puede no ser de pilates, y hasta uno que lo
 * sea no tiene por qué leer el identificador interno de la base de datos.
 */
export const SUSCRIPCION_DOMICILIACION = 'pilates-domiciliacion';
export const SUSCRIPCION_OTROS_PAGOS = 'pilates-otros-pagos';

const ETIQUETAS: Record<string, string> = {
    [SUSCRIPCION_DOMICILIACION]: 'Domiciliación',
    [SUSCRIPCION_OTROS_PAGOS]: 'Otros pagos',
};

/**
 * Nombre legible de un tipo de suscripción. Si aparece un valor desconocido se
 * devuelve tal cual —mejor eso que una cadena vacía— pero sin el prefijo de
 * actividad, que es justo lo que sobra.
 */
export const etiquetaSuscripcion = (nombre?: string | null): string => {
    if (!nombre) return '—';
    return ETIQUETAS[nombre] ?? nombre.replace(/^pilates-/, '');
};
